import {
  type AxiosInstance,
  HttpStatusCode,
  isAxiosError,
  type AxiosError,
} from "axios";
import { SendToTrackingService } from "@/api/handlers/errors";
import useSWR, { type KeyedMutator } from "swr";

interface IPictureRequestAmount {
  shoyushajiko: number | null;
  zenbujiko: number | null;
  chisekisokuryozu: number | null;
  denshikozu: number | null;
  chiekikenzumen: number | null;
  tatemonozumen: number | null;
}

interface IResponse {
  data: IPictureRequestAmount | undefined;
  isLoading: boolean;
  mutate: KeyedMutator<IPictureRequestAmount>;
  error: AxiosError | undefined;
}

const url = "/picture-request/amount";

export const usePictureRequestAmount = (
  apiClient: AxiosInstance
): IResponse => {
  const fetcher = async (): Promise<IPictureRequestAmount> => {
    try {
      const response = await apiClient.get<IPictureRequestAmount>(url);
      return response.data;
    } catch (error) {
      if (
        isAxiosError(error) &&
        (error.response?.status ?? HttpStatusCode.InternalServerError) >=
          HttpStatusCode.InternalServerError
      ) {
        SendToTrackingService(error);
      }
      throw error;
    }
  };

  const { data, isLoading, mutate, error } = useSWR<
    IPictureRequestAmount,
    AxiosError
  >(url, fetcher, {
    errorRetryInterval: 120_000, // NOTE: バックエンドの120秒制限に合わせる
    revalidateOnFocus: false,
  });

  return { data, isLoading, mutate, error };
};
